import Vue from 'vue'
import App from './App.vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router';
import { ROUTE_NAMES, router } from './router';
import { getInitialStore } from './store';
import {
  API_URL as apiURL,
  PRIZE_CHOICES_URL as prizeChoicesURL,
  PRIZE_URL as prizeURL,
  STATIC_URL as staticURL,
  PRP_FLOW_V2 as PrpFlowV2
} from '../shared/constants';
import { getPrpFlowVersion } from '../shared/utils';

export const STATIC_URL = staticURL;
export const API_URL = apiURL;
export const PRIZE_CHOICES_URL = prizeChoicesURL;
export const PRIZE_URL = prizeURL;

Vue.use(Vuex);
Vue.use(VueRouter);

export default new Vue({
  el: '#funnel-reg13',
  router,
  components: { App: App },
  store: getInitialStore(),
  template: '<App />'
})

export function updateProgressBar(store) {
  const maxPageProgressValue = 90; // because the last page shows the progress as 90% instead of 100%
  const routeNames = Object.values(ROUTE_NAMES);
  const totalPagesToExclude = getPrpFlowVersion() === PrpFlowV2 ? 4 : 1; // exclude signup
  let totalPages = routeNames.length - totalPagesToExclude;
  totalPages = totalPages <= 0 ? 1 : totalPages;
  const currentPath = window.location.hash.replace('#', '');
  const matchingRoute = routeNames.find(e => e === currentPath)
  let currentPageIndex = routeNames.indexOf(matchingRoute) + 1;
  currentPageIndex = currentPageIndex > totalPages ? totalPages : currentPageIndex;
  const newValue = Math.floor((currentPageIndex * maxPageProgressValue) / totalPages);
  store.commit('updateProgress', newValue);
}

export function trackGoalChanging(originalGoal, newGoal) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'funnel_goal_changed',
    old_goal_in_lbs: parseInt(originalGoal),
    new_goal_in_lbs: parseInt(newGoal)
  });
}
